import type { RouteMetaArgs } from '~/types/meta-args';
import { getRouteData } from '~/modules/root/util/get-route-data';

export const getMetaBaseUrl = (metaArgs: Pick<RouteMetaArgs, 'matches'>) => {
    const { matches } = metaArgs;
    const { rootData } = getRouteData(matches);
    if (!rootData) return '';
    return 'https://' + rootData.env.host;
};
